import { render } from "./home-grid-single-text.vue?vue&type=template&id=d33e4bae&scoped=true"
import script from "./home-grid-single-text.vue?vue&type=script&lang=js"
export * from "./home-grid-single-text.vue?vue&type=script&lang=js"

import "./home-grid-single-text.vue?vue&type=style&index=0&id=d33e4bae&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d33e4bae"]])

export default __exports__